import { Spacer, Tickbox } from '@adserve/adserve-react-components';
import React from 'react';
import {
    favouritesTextStyle,
    fixedInfoTextStyle,
    isFavouriteContainerStyle,
    referenceNumbersPanelStyle
} from './CampaignBriefStyles';
import { pageContainerStyle } from '../CampaignStyles';
import { showSaveBar } from '../CampaignUtils';
import SaveBar from '../../SaveBar/SaveBar';

const ReferenceAndSavePanel = ({
    campaign,
    createCampaign,
    updateCampaign,
    currentStep,
    readOnly = false,
    bookedReadOnly = false,
    validCampaignName,
    validCampaignGoal,
    validCategory,
    validDeal,
    validDates,
    handleUpdateWithMessage,
    setReadOnlyProperty,
    campaignSaving
}) => {
    const toggleFavourite = () => {
        if (readOnly) return;
        updateCampaign('isFavourite', !campaign.isFavourite);
    };


    const isAnyReadOnly = () => {
        let isAnyNotReadonly = bookedReadOnly;
        if (isAnyNotReadonly) isAnyNotReadonly = readOnly;
        return isAnyNotReadonly
    };

    return (
        <>
            {currentStep === 0 ? (
                <div
                    style={{
                        ...referenceNumbersPanelStyle,
                        ...pageContainerStyle,
                        marginBottom: 45
                    }}
                >
                    <div style={{ display: 'flex' }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-end',
                                width: '90%'
                            }}
                        >
                            <div
                                style={isFavouriteContainerStyle(readOnly)}
                                onClick={toggleFavourite}
                                id={'campaign-favourite-input'}
                            >
                                <Tickbox
                                    height={18}
                                    width={18}
                                    value={campaign?.isFavourite}
                                    disabled={readOnly}
                                    id={'campaign-favourite-tickbox-input'}
                                />

                                <Spacer height={0} width={16} />

                                <div>
                                    <span style={favouritesTextStyle}>{window.translate('Add to Favourites')}</span>
                                </div>
                            </div>
                            <div id={'campaign-referenceid-input'} style={{ paddingRight: 59 }}>
                                <span style={fixedInfoTextStyle}>
                                    {window.translate('Campaign Number')}
                                    {': '}
                                    {campaign?.id === window.emptyGuid ? 'XXXXXXXXXX' : campaign?.referenceNumber}
                                </span>
                            </div>
                            <div id={'campaign-externalreferenceid-input'} style={{ paddingRight: 57 }}>
                                <span style={fixedInfoTextStyle}>
                                    {window.translate('External Reference ID')}
                                    {': '}
                                    {campaign?.id === window.emptyGuid ? 'XXXXXXXXXX' : campaign?.externalSourceRef}
                                </span>
                            </div>
                        </div>

                        <SaveBar
                            campaign={campaign}
                            handleCreate={createCampaign}
                            handleUpdate={handleUpdateWithMessage}
                            isSticky={currentStep !== 0}
                            readOnly={isAnyReadOnly() || !validCampaignName || !validDates || !campaign?.modified}
                            display={showSaveBar(
                                campaign?.businessType,
                                currentStep,
                                campaign?.billingTermName === 'Bespoke'
                            )}
                            campaignSaving={campaignSaving}
                        />
                    </div>
                </div>
            ) : (
                <SaveBar
                    campaign={campaign}
                    handleCreate={createCampaign}
                    handleUpdate={handleUpdateWithMessage}
                    isSticky={currentStep !== 0}
                    readOnly={isAnyReadOnly() || !validCampaignName || !validCampaignGoal || !validCategory || !validDeal || !validDates || setReadOnlyProperty}
                    display={showSaveBar(campaign?.businessType, currentStep, campaign?.billingTermName === 'Bespoke')}
                    campaignSaving={campaignSaving}
                />
            )}
        </>
    );
};

export default ReferenceAndSavePanel;
